import { getProject } from '../getProject';

import { RepoAlreadyExistsProps, ValidationResult } from './types';

export const repoAlreadyExists = async (
  props: RepoAlreadyExistsProps,
): Promise<ValidationResult> => {
  const { projectId } = await getProject(props);
  return {
    error: 'Repository already exists.',
    result: projectId ? 'failed' : 'success',
    details: projectId ? `${props.repoLocation}/${props.repoName}` : '',
    fix: 'Either rename the template or change the location.',
  };
};
